import { getBookedAddressByStreet, getSelectedOnsiteAddress } from './utils'

import type { ProviderInfo } from '../../models/providers/Providers'

const MAP_URL_BASE = 'https://www.google.com/maps/place/'

/**
 * Generates a Google Maps URL for the appointment's in-person address.
 *
 * Resolves the address in priority order: locationId match, booked address string
 * match, then nearestAddress fallback.
 *
 * Returns `undefined` when there is no appointment or no address can be resolved.
 */
export const getMapUrlForAppointment = (appointment?: {
  address?: string
  locationId?: string | null
  provider?: Pick<ProviderInfo, 'nearestAddress' | 'addresses'> | null
}): string | undefined => {
  if (!appointment) {
    return
  }

  const locationId = appointment.locationId ? Number(appointment.locationId) : undefined
  const address =
    getSelectedOnsiteAddress(locationId, appointment.provider?.addresses) ??
    getBookedAddressByStreet(appointment.address, appointment.provider?.addresses) ??
    appointment?.provider?.nearestAddress ??
    null
  const location = address ? address?.location : null
  let addressQuery = ''
  let locationQuery = ''

  if (!address) {
    return
  }

  const street1 = address?.street1
  const street2 = address?.street2 ? `, ${address?.street2}` : ''
  const city = address?.city
  const state = address?.state
  const zipcode = address?.zipcode

  addressQuery = `${street1}${street2}, ${city}, ${state} ${zipcode}`.replace(/ /g, '+')

  if (location) {
    const lat = location?.lat
    const lon = location?.lon
    const zoom = '16z' // hard-coded zoom level

    locationQuery = `/@${lat},${lon},${zoom}`
  }

  return MAP_URL_BASE + addressQuery + locationQuery
}
